module.exports = __webpack_public_path__ + "img/logo.ac42cad8.png";